<div *ngIf="loading == true" class="loading">
    <mat-spinner class="spinner-custom" [diameter]="55" color="accent"></mat-spinner>
</div>

<div *ngIf="flag === false">

    <mat-card class="card-primary mat-elevation-z" *ngIf="lang =='esp'">
        <mat-card-content>
            <img src="https://go-fit.es/wp-content/uploads/2022/04/Logo-GO-fit-LIFE-SCIENCE-TECH_RGB_02-1.svg"
                alt="logo Gofit" class="logo">

            <mat-card-title class="title">
                Lo sentimos no hemos podido obtener informacion de su encuesta.
            </mat-card-title>
            <p>Compruebe que esta accediendo a la encuesta mas reciente en su correo electronico. Si el problema
                continua puede comunicarse con el soporte tecnico de esta aplicacion.</p>

        </mat-card-content>
        <mat-card-footer>
            <button>Entiendo</button>
        </mat-card-footer>
    </mat-card>
    <mat-card *ngIf="lang =='eng'">
        <mat-card-title class="title">
            An error has occurred.
        </mat-card-title>
        <mat-card-content>
            <p>This can happen because you are entering an expired or wrong link.</p>
        </mat-card-content>
    </mat-card>
</div>
<mat-card class="card-primary mat-elevation-z">

    <mat-card-content *ngIf="lang =='esp'">
        <img src="https://www.cpcesfe2.org.ar/wp-content/themes/consejo/img/logo.png" alt="">
        <h2>Bienvenido <span class="capitalize">{{survey.relationCustomer.nombre}} {{survey.relationCustomer.apellidos}}
            </span></h2>
        <p>Haz click para completar esta encuesta, será un proceso rápido y sencillo.</p>
        <button mat-flat-button class="full-bt" (click)="startSurvey();" color="accent">Comenzar</button>
    </mat-card-content>

</mat-card>